import { getFloat } from '@assets/utils/Formatting';
import { isString } from 'lodash';

export class ChartUtils {
    static SHADOW_FILTER = 'drop-shadow(3px 1px 4px rgba(0, 0, 0, 0.5))';
    //    static GOLD_COLOR = ['#bfae5a', '#d9c666'];
    static GOLD_COLOR = ['#bfae5a', '#b8a858'];

    static BLUE_COLOR = ['#243a5c', '#657e96'];
    //243a5c  657e96

    static genColorGradientHorizontal(id: string, colors: string[]) {
        return (
            <>
                <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor={colors[0]} stopOpacity={1} />
                    <stop offset="30%" stopColor={colors[0]} stopOpacity={1} />
                    <stop offset="100%" stopColor={colors[1]} stopOpacity={1} />
                </linearGradient>
            </>
        );
    }

    static getBarGradient = () => {
        return (
            <>
                {ChartUtils.genColorGradientHorizontal(
                    'barGradientBlue',
                    ChartUtils.BLUE_COLOR
                )}

                {ChartUtils.genColorGradientHorizontal(
                    'barGradientGold',
                    ChartUtils.GOLD_COLOR
                )}
            </>
        );
    };
    static formatCurrency = (v: number) => {
        if (isString(v)) {
            v = getFloat(v);
        }
        if (v == 0 || isNaN(v)) {
            return 'N/A';
        }
        return '$' + v.toFixed(0);
    };

    static formatPercent = (v: number) => {
        if (v == 0 || isNaN(v)) {
            return 'N/A';
        }
        return v.toFixed(0) + '%';
    };
}
